export default __webpack_public_path__ + "static/media/icon-arrow-down-blue.b4f2d9a2.svg";